function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["item", "index", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useLocale, pickKeys } from '@adsk/alloy-react-helpers';
import Overlay, { OverlayDeprecated } from '@adsk/alloy-react-overlay';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme from '@adsk/alloy-react-theme';
import { CREATE_TYPE, defaultItemRenderer, defaultFilterOptions, defaultMenuRenderer } from './defaultRenderers';
/**
 * SelectBoxControl
 */

var SelectBoxMenu = /*#__PURE__*/function (_Component) {
  _inherits(SelectBoxMenu, _Component);

  var _super = _createSuper(SelectBoxMenu);

  function SelectBoxMenu(props) {
    var _this;

    _classCallCheck(this, SelectBoxMenu);

    _this = _super.call(this, props);
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    _this.getOptionLabel = _this.getOptionLabel.bind(_assertThisInitialized(_this));
    var multiple = props.multiple,
        selectedValue = props.selectedValue,
        stateAndHelpers = props.stateAndHelpers;
    _this.prevInputValue = stateAndHelpers.inputValue;
    var selectedItems = multiple ? selectedValue : [];
    _this.filteredSelectedItems = _this.filterOptions(selectedItems, _this.prevInputValue);
    return _this;
  }

  _createClass(SelectBoxMenu, [{
    key: "getOptionLabel",
    value: function getOptionLabel(item) {
      var _this$props = this.props,
          labelGetter = _this$props.labelGetter,
          labelKey = _this$props.labelKey;
      return labelGetter && labelGetter(item) || item[labelKey] || '';
    }
  }, {
    key: "filterOptions",
    value: function filterOptions(options, inputValue) {
      var _this$props2 = this.props,
          searchable = _this$props2.searchable,
          _this$props2$filterOp = _this$props2.filterOptions,
          filterOptions = _this$props2$filterOp === void 0 ? defaultFilterOptions : _this$props2$filterOp;
      if (!searchable) return options;
      return filterOptions(options, inputValue, this.props);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props3 = this.props,
          stateAndHelpers = _this$props3.stateAndHelpers,
          multiple = _this$props3.multiple,
          creatable = _this$props3.creatable,
          selectedValue = _this$props3.selectedValue,
          isSameItem = _this$props3.isSameItem,
          options = _this$props3.options,
          labelKey = _this$props3.labelKey,
          valueKey = _this$props3.valueKey,
          showValueAsTags = _this$props3.showValueAsTags,
          keepSelectedOnOptionsChange = _this$props3.keepSelectedOnOptionsChange;
      var inputValue = stateAndHelpers.inputValue;
      var filteredOptions = this.filterOptions(options, inputValue);

      if (creatable && inputValue) {
        var search = inputValue.trim();

        if (!filteredOptions.find(function (x) {
          return _this2.getOptionLabel(x) === search || x[valueKey] === search;
        })) {
          var _createOption;

          var createOption = (_createOption = {}, _defineProperty(_createOption, valueKey, search), _defineProperty(_createOption, labelKey, search), _defineProperty(_createOption, CREATE_TYPE, true), _createOption);
          filteredOptions.unshift(createOption);
        }
      }

      if (showValueAsTags) return filteredOptions;

      if (multiple && inputValue !== this.prevInputValue) {
        this.prevInputValue = inputValue;
        this.filteredSelectedItems = this.filterOptions(multiple ? selectedValue : [], this.prevInputValue);
      }

      if (this.filteredSelectedItems.length === 0) return filteredOptions;
      var selectedOptions = [];
      var otherOptions = [];
      filteredOptions.forEach(function (item) {
        if (_this2.filteredSelectedItems.find(function (x) {
          return isSameItem(x, item);
        })) selectedOptions.push(item);else otherOptions.push(item);
      });

      if (keepSelectedOnOptionsChange) {
        // in case some selected items are not in the current options
        this.filteredSelectedItems.length !== selectedOptions.length && this.filteredSelectedItems.forEach(function (item) {
          if (!selectedOptions.find(function (x) {
            return isSameItem(x, item);
          })) selectedOptions.push(item);
        });
      }

      return selectedOptions.concat(otherOptions);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          style = _this$props4.style,
          stateAndHelpers = _this$props4.stateAndHelpers,
          selectedValue = _this$props4.selectedValue,
          isLoading = _this$props4.isLoading,
          maxMenuHeight = _this$props4.maxMenuHeight,
          _this$props4$menuRend = _this$props4.menuRenderer,
          menuRenderer = _this$props4$menuRend === void 0 ? defaultMenuRenderer : _this$props4$menuRend,
          _this$props4$noResult = _this$props4.noResultsValue,
          noResultsValue = _this$props4$noResult === void 0 ? this.props['T'].translate('NO_RESULTS') : _this$props4$noResult,
          _this$props4$noResult2 = _this$props4.noResultsPlaceholder,
          noResultsPlaceholder = _this$props4$noResult2 === void 0 ? true : _this$props4$noResult2;
      var highlightedIndex = stateAndHelpers.highlightedIndex;
      if (isLoading) return /*#__PURE__*/React.createElement(_StyledDiv, {
        $_css: [{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: maxMenuHeight
        }]
      }, /*#__PURE__*/React.createElement(ProgressRing, null));
      var items = this.getOptions();

      if (items.length === 0) {
        return /*#__PURE__*/React.createElement(_StyledDiv2, {
          $_css2: [{
            padding: '8px 10px',
            color: theme.colors.charcoal500,
            display: noResultsPlaceholder ? 'block' : 'none'
          }]
        }, noResultsValue);
      }

      return /*#__PURE__*/React.createElement(_StyledUl, {
        className: className,
        $_css3: [{
          borderRadius: 4,
          margin: 0,
          padding: 0,
          listStyle: 'none',
          overflow: 'auto',
          maxHeight: maxMenuHeight
        }, style]
      }, menuRenderer({
        items: items,
        renderItem: this.renderItem,
        selectedValue: selectedValue,
        highlightedIndex: highlightedIndex,
        selectProps: this.props
      }));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _objectSpread2;

      var _this$props5 = this.props,
          stateAndHelpers = _this$props5.stateAndHelpers,
          clearable = _this$props5.clearable,
          isSelected = _this$props5.isSelected,
          footerRenderer = _this$props5.footerRenderer;
      var clearSelection = stateAndHelpers.clearSelection;
      var showClear = clearable && isSelected;
      var footer = footerRenderer && footerRenderer(this.props);
      if (!showClear && !footer) return null;
      return /*#__PURE__*/React.createElement(_StyledDiv3, {
        $_css4: [{
          borderTop: "1px solid ".concat(theme.colors.charcoal200)
        }]
      }, footer, showClear && /*#__PURE__*/React.createElement(_StyledButton, {
        onClick: clearSelection,
        type: "button",
        "data-testid": "SelectBox__clear",
        $_css5: [_objectSpread(_objectSpread({}, theme.typography.labelSmall), {}, (_objectSpread2 = {
          backgroundColor: theme.colors.white,
          border: 'none',
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
          color: theme.colors.adskBlue700,
          cursor: 'pointer',
          outline: 'none',
          padding: '15px 16px',
          textAlign: 'right',
          width: '100%'
        }, _defineProperty(_objectSpread2, '&:not(:first-child)', {
          borderTop: '1px solid gray'
        }), _defineProperty(_objectSpread2, '&[disabled]', {
          color: '#EDF0F2',
          cursor: 'default'
        }), _objectSpread2))]
      }, this.props['T'].translate('CLEAR')));
    }
  }, {
    key: "renderItem",
    value: function renderItem(_ref) {
      var item = _ref.item,
          index = _ref.index,
          className = _ref.className,
          rest = _objectWithoutProperties(_ref, _excluded);

      var _this$props6 = this.props,
          stateAndHelpers = _this$props6.stateAndHelpers,
          multiple = _this$props6.multiple,
          selectedValue = _this$props6.selectedValue,
          isSameItem = _this$props6.isSameItem,
          isOptionDisabled = _this$props6.isOptionDisabled,
          showValueAsTags = _this$props6.showValueAsTags,
          valueKey = _this$props6.valueKey,
          _this$props6$itemRend = _this$props6.itemRenderer,
          itemRenderer = _this$props6$itemRend === void 0 ? defaultItemRenderer : _this$props6$itemRend;
      var getItemProps = stateAndHelpers.getItemProps,
          highlightedIndex = stateAndHelpers.highlightedIndex;
      var selected = multiple ? selectedValue.find(function (x) {
        return isSameItem(x, item);
      }) : selectedValue && isSameItem(selectedValue, item);
      var lastSelected = multiple && !showValueAsTags && index === this.filteredSelectedItems.length - 1;
      var showSeparator = this.filteredSelectedItems.length > 0;
      var disabled = isOptionDisabled && isOptionDisabled(item, index, this.props);
      var itemProps = getItemProps(_objectSpread({
        item: item,
        index: index,
        disabled: disabled,
        selected: selected,
        key: item[valueKey],
        className: className,
        create: item[CREATE_TYPE] && !selected,
        highlighted: !disabled && index === highlightedIndex,
        lastSelected: lastSelected && showSeparator
      }, rest));
      return itemRenderer({
        item: item,
        index: index,
        disabled: disabled,
        selected: selected,
        itemProps: itemProps,
        selectProps: this.props
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props7 = this.props,
          stateAndHelpers = _this$props7.stateAndHelpers,
          placement = _this$props7.placement,
          container = _this$props7.container,
          target = _this$props7.target,
          overlayClassName = _this$props7.overlayClassName,
          overlayStyle = _this$props7.overlayStyle,
          selectedValue = _this$props7.selectedValue,
          multiple = _this$props7.multiple;
      var numSelected = multiple ? selectedValue.length : !!selectedValue;
      return /*#__PURE__*/React.createElement(OverlayDeprecated, {
        show: true,
        target: target,
        container: container || null,
        placement: placement,
        layoutDependency: this.getOptions().length + numSelected
      }, function (_ref2) {
        var _target$current;

        var props = _ref2.props,
            placement = _ref2.placement;
        return /*#__PURE__*/React.createElement(Overlay.Container, {
          "data-testid": "SelectBox__menu",
          ref: props.ref,
          className: overlayClassName,
          placement: placement,
          variant: Overlay.VARIANTS.LIGHT,
          style: [{
            maxWidth: 'calc(100% + 70px)',
            width: (target === null || target === void 0 ? void 0 : (_target$current = target.current) === null || _target$current === void 0 ? void 0 : _target$current.offsetWidth) || 'auto'
          }, props.style, overlayStyle]
        }, /*#__PURE__*/React.createElement("div", stateAndHelpers.getMenuProps(), _this3.renderContent(), _this3.renderFooter()));
      });
    }
  }]);

  return SelectBoxMenu;
}(Component);

SelectBoxMenu.displayName = 'SelectBoxMenu';
SelectBoxMenu.defaultProps = {
  maxMenuHeight: 300
};
SelectBoxMenu.propTypes = _objectSpread(_objectSpread({}, pickKeys(Overlay.propTypes, ['container', 'placement'])), {}, {
  /**
   * Class name for the component
   */
  className: PropTypes.string,

  /**
   * style for the component
   */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /**
   * i18n helper for T.translate('KEY')
   */
  T: PropTypes.object,

  /**
   * Whether the component is disabled
   */
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * Whether the component is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Whether the component is searchable
   */
  searchable: PropTypes.bool,

  /**
   * stateAndHelpers pass to control from select
   */
  stateAndHelpers: PropTypes.shape({
    isOpen: PropTypes.bool,
    openMenu: PropTypes.func,
    closeMenu: PropTypes.func,
    clearSelection: PropTypes.func,
    getMenuProps: PropTypes.func,
    getItemProps: PropTypes.func,
    type: PropTypes.string,
    inputValue: PropTypes.string,
    highlightedIndex: PropTypes.number
  }),

  /**
   * `(inputValue, stateAndHelpers) => *`, callback when searching
   */
  onInputChange: PropTypes.func,

  /**
   * Whether the component is multi selectable
   */
  multiple: PropTypes.bool,

  /**
   * selectedValue
   */
  selectedValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /**
   * The key of the option value
   */
  valueKey: PropTypes.string,

  /**
   * The placeholder for the component
   */
  placeholder: PropTypes.node,

  /**
   * The placeholder for the component when searching
   */
  searchPlaceholder: PropTypes.node,

  /**
   * Whether the item is Selected
   */
  isSelected: PropTypes.bool,

  /**
   * Container for the menu, the menu would be rendered on an overlay if set
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * Whether to show value as tags
   */
  showValueAsTags: PropTypes.bool,

  /**
   * The key of the option label
   */
  labelKey: PropTypes.string,

  /**
   * `(option) => string`, option label formatter
   */
  labelGetter: PropTypes.func,

  /**
   * `(options, inputValue, selectProps) => array`, filter options based on input value
   */
  filterOptions: PropTypes.func,

  /**
   * Whether the component is creatable
   */
  creatable: PropTypes.bool,

  /**
   * Whether the item is the same
   */
  isSameItem: PropTypes.func,

  /**
   * Controlled selected value for the component
   */
  options: PropTypes.arrayOf(PropTypes.object),

  /**
   * Class name for the overlay
   */
  overlayClassName: PropTypes.string,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: PropTypes.any,

  /**
   * Class name for the menu
   */
  menuClassName: PropTypes.string,

  /**
   * `({ item, index, disabled, selected, itemProps, selectProps }) => node`, custom item renderer
   */
  itemRenderer: PropTypes.func,

  /**
   * `(option, index, selectProps) => boolean`, whether the option is disabled
   */
  isOptionDisabled: PropTypes.func,

  /**
   * Whether the component is loading options
   */
  isLoading: PropTypes.bool,

  /**
   * The max height of the menu, the footer is not included
   */
  maxMenuHeight: PropTypes.number,

  /**
   * `({ items, renderItem, selectedValue, highlightedIndex, selectProps }) => node`, custom menu renderer
   */
  menuRenderer: PropTypes.func,

  /**
   * The content to be shown if the filtered options is empty
   */
  noResultsValue: PropTypes.node,

  /**
   * Whether the component is clearable
   */
  clearable: PropTypes.bool,

  /**
   * `(selectProps) => node`, custom footer renderer
   */
  footerRenderer: PropTypes.func,

  /**
   * Specify where the SelectBoxMenu element is positioned
   * in relation to the target element
   */
  placement: PropTypes.oneOf(Object.values(Overlay.PLACEMENTS))
});

var WrapperSelectBoxMenu = function WrapperSelectBoxMenu(props) {
  var _useLocale = useLocale(function (_ref3) {
    var locale = _ref3.locale;
    return require("../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(SelectBoxMenu, _extends({}, props, {
    T: T
  }));
};

export default WrapperSelectBoxMenu;

var _StyledDiv = _styled("div").withConfig({
  displayName: "SelectBoxMenu___StyledDiv",
  componentId: "sc-y1w0bt-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "SelectBoxMenu___StyledDiv2",
  componentId: "sc-y1w0bt-1"
})(["", ""], function (p) {
  return p.$_css2;
});

var _StyledUl = _styled("ul").withConfig({
  displayName: "SelectBoxMenu___StyledUl",
  componentId: "sc-y1w0bt-2"
})(["", ""], function (p) {
  return p.$_css3;
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "SelectBoxMenu___StyledDiv3",
  componentId: "sc-y1w0bt-3"
})(["", ""], function (p) {
  return p.$_css4;
});

var _StyledButton = _styled("button").withConfig({
  displayName: "SelectBoxMenu___StyledButton",
  componentId: "sc-y1w0bt-4"
})(["", ""], function (p) {
  return p.$_css5;
});
//# sourceMappingURL=SelectBoxMenu.js.map